import React from 'react';
import PropTypes from 'prop-types';
import {Box, Text} from '@tenancy.nz/ui';
import Icon from './Icon';
import {isString} from '../utils/helpers';

function IconLabel({
  color = 'primary',
  icon,
  iconSize = '24px',
  size = '13px',
  text = undefined,
  sx = {},
}) {
  if (!text) {
    return null;
  }
  return (
    <Box display="inline-flex" align="center" gap="5px" fontSize={size} {...sx}>
      {isString(icon) ? (
        <Icon color={color} name={icon} size={iconSize} />
      ) : (
        icon
      )}
      <Text as="span" variant="inherit" weight="600">
        {text}
      </Text>
    </Box>
  );
}

IconLabel.propTypes = {
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'tertiary']),
  icon: PropTypes.node.isRequired,
  iconSize: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.shape({}),
};

export default IconLabel;
